import { render, staticRenderFns } from "./StdbSearchProblem.vue?vue&type=template&id=62b50c90&scoped=true"
import script from "./StdbSearchProblem.vue?vue&type=script&lang=js"
export * from "./StdbSearchProblem.vue?vue&type=script&lang=js"
import style0 from "./StdbSearchProblem.vue?vue&type=style&index=0&id=62b50c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b50c90",
  null
  
)

export default component.exports